import { Component  } from 'react';
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  getAgentForm,
  saveAgentResponse,
  saveAgentResponseAsDraft,
  stopAIAgent,
} from "./../../../config/agent_forms_api_calls";
import $ from "jquery";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";
import FormRendererAgent from "../../../components/Reseller/formRenderAgent";
import NotificationToast from "../../../components/Notification/NotificationToast";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import dateFormat from "dateformat";
import CryptoJS from "crypto-js";
import axios from "axios";

const auth = new HelperClass();

class FormSubmit extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      errorMessage: "",
      successMessage: "",
      showModal: false,
      modalContent: null,
      formAccNo: "",
      successMessageSaveResponse: "",
      errorMessageSaveResponse: "",
      form_accountno: "",
      form_token: "",
      formData: "",
      form_title: "",
      form_desc: "",
      client_details: [],
      form_submitted: "3",
      allow_multiple: 0,
      responseMessage: "",
      allow_submit: 1,
      link_form: false,
      captcha_enabled: 0,
      external_link: "",
      draftData: [],
      progressStep: 0,
      totalSteps: 0,
      chatgpt_intergation: "No",
      conversational_ai: "No",
      chatgpt_api_key: "",
      isStoppingAgent: false,
      allow_agent_name: false,
      isSubmitting: false,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      apiFieldErrors: null,
    };
  }

  showToast = (message, type = "error", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: message,
        toastType: type,
        toastTitle: title || (type === "success" ? "Success" : "Error"),
      })
    );
  };

  async componentDidMount() {
    let form_accountno = this.props.props.match.params.form_accountno;
    let form_token = this.props.props.match.params.form_token;
    this.setState({
      formAccNo: form_accountno,
      form_token: form_token,
    });
    const servicesResponce = await getAgentForm(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      form_token
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        form_submitted: "3",
      });
    } else if (servicesResponce.data.status === 200) {
      let from_table = servicesResponce.data.from_table;
      const groupsData = servicesResponce.data.data[0]["groups"];
      const groups = groupsData ? JSON.parse(groupsData) : [];

      //const draftResponse = servicesResponce.data.client_data[0]["response"];
      const draftResponse = servicesResponce.data.draft_response;
      const draftData =
        draftResponse && draftResponse !== "" ? JSON.parse(draftResponse) : [];
      //const progress = servicesResponce.data.data[0]["progress"];

      let progress = "";
      if (from_table === "submission") {
        progress = servicesResponce.data.progress;
      }
      let progressStep = 0;
      if (progress) {
        const [current, total] = progress.split("/").map(Number);
        progressStep = current < total ? current : 0;
      }

      let form_submitted = 0;
      let allow_multiple = 0;
      if (from_table === "main") {
        form_submitted = servicesResponce.data.client_data[0]["is_filled"];
        allow_multiple = servicesResponce.data.client_data[0]["allow_multiple"];
      } else {
        if (servicesResponce.data.is_submitted === 0) {
          form_submitted = "No";
        } else if (servicesResponce.data.is_submitted === 1) {
          form_submitted = "Yes";
        }

        allow_multiple = servicesResponce.data.data[0]["allow_multiple"];
      }

      let chatgpt_intergation = "No";
      let conversational_ai = "No";
      let chatgpt_api_key = "";

      if (
        servicesResponce.data.integrationInfo &&
        servicesResponce.data.integrationInfo.length > 0
      ) {
        for (let i = 0; i < servicesResponce.data.integrationInfo.length; i++) {
          const item = servicesResponce.data.integrationInfo[i];
          if (
            item["integration_type"] === "chatgpt" &&
            item["active"] === 1 &&
            item["enabled"] === "Yes"
          ) {
            chatgpt_intergation = "Yes";
            if (item["api_key"]) {
              chatgpt_api_key = this.decryptApiKey(item["api_key"]);
            }
          }

          if (
            item["integration_type"] === "conversational" &&
            item["active"] === 1 &&
            item["enabled"] === "Yes"
          ) {
            conversational_ai = "Yes";
          }
        }
      }

      const aiAgentCreation =
        servicesResponce.data.data[0]["ai_agent_creation"] === 1;
      const aiAgentLink =
        servicesResponce.data.data[0]["ai_agent_creation_external_link"];

      const allow_agent_name = aiAgentCreation && aiAgentLink ? true : false;

      this.setState({
        formData: servicesResponce.data.data[0]["form_content"],
        form_title: servicesResponce.data.data[0]["form_title"],
        form_desc: servicesResponce.data.data[0]["form_desc"],
        allow_submit: servicesResponce.data.data[0]["allow_submit"],
        link_form: servicesResponce.data.data[0]["link_form"],
        captcha_enabled: servicesResponce.data.data[0]["captcha_enabled"] || 0,
        external_link: servicesResponce.data.data[0]["external_link"],
        groups: groups,
        client_details: servicesResponce.data.client_details,
        form_submitted: form_submitted,
        allow_multiple: allow_multiple,
        draftData: draftData,
        progressStep: progressStep,
        totalSteps: groups.length,
        tableLoader: false,
        tableLoaderListing: false,
        chatgpt_intergation: chatgpt_intergation,
        chatgpt_api_key: chatgpt_api_key,
        conversational_ai: conversational_ai,
        allow_agent_name: allow_agent_name,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        form_submitted: "3",
      });
      //window.location.replace("/error");
    }
  }

  decryptApiKey = (encryptedValue) => {
    if (!encryptedValue || typeof encryptedValue !== "string") {
      console.error("decryptApiKey: Invalid encrypted value");
      return "";
    }

    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedValue,
        process.env.REACT_APP_SECRET_AES
      );
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted) {
        console.error("Decryption resulted in empty string");
        return "";
      }

      return decrypted;
    } catch (err) {
      console.error("Decryption failed:", err);
      return "";
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  openModal = (formData, formAccNo) => {
    const modalContent = (
      <FormRendererAgent
        formData={JSON.parse(formData)}
        formTitle={this.state.form_title}
        onSubmit={this.handleSubmitForm}
        captcha_enabled={this.state.captcha_enabled}
        link_form={this.state.link_form}
        // id={this.state.forms[0].id}
        // setShowResponse={(value) => this.setState({ showResponse: value })}
      />
    );
    this.setState({ modalContent: modalContent, formAccNo: formAccNo }, () => {
      window.$("#modalPreviewForm").modal("show");
    });
  };

  closeModal = () => {
    this.setState({ modalContent: null, formAccNo: "" }, () => {
      window.$("#modalPreviewForm").modal("hide");
    });
  };

  handleSaveDraft = (formData, currentStep) => {
    let response = JSON.stringify(formData);
    let form_accountno = this.props.props.match.params.form_accountno;
    this.saveDraft(response, form_accountno, currentStep);
  };

  saveDraft = async (response, formAccNo, submittedStep) => {
    const { form_token, form_title, form_desc, totalSteps } = this.state;
    window.scrollTo({ top: 0, behavior: "smooth" });
    const submitFormReponse = await saveAgentResponseAsDraft(
      auth.getAccount(),
      response,
      formAccNo,
      form_token,
      form_title,
      form_desc,
      submittedStep,
      totalSteps
    );
    // console.log("saveResponse response: ", submitFormReponse.data);
    if (
      submitFormReponse.data.status === 403 ||
      submitFormReponse.data.errors === "authentication missing" ||
      submitFormReponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (submitFormReponse.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        responseMessage:
          '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while saving the progress.</div>',
      });
      return false;
    } else if (submitFormReponse.data.status === 200) {
      return true;
    }
    setTimeout(() => {
      this.setState({
        errorMessageSaveResponse: "",
        responseMessage: "",
      });
    }, 2000);
  };

  handleSubmitForm = (formData) => {
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.formAccNo);
  };

  saveResponse = async (response, formAccNo) => {
    const { form_token, form_title, form_desc, totalSteps } = this.state;

    window.scrollTo({ top: 0, behavior: "smooth" });
    this.setState({ isSubmitting: true, apiFieldErrors: null }); // 🟡 start loader

    try {
      const submitFormReponse = await saveAgentResponse(
        auth.getAccount(),
        auth.getToken(),
        response,
        formAccNo,
        form_token,
        form_title,
        form_desc,
        totalSteps
      );

      const data = submitFormReponse.data || {};

      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (data.status === 404) {
        const fieldErrors = data.field_errors;
        const fallbackMsg =
          (typeof data.errors === "string" ? data.errors : data.errors?.message) ||
          data.message ||
          "There was an error submitting the form.";
        if (fieldErrors && typeof fieldErrors === "object") {
          const firstError = Object.values(fieldErrors)
            .flat()
            .find((msg) => typeof msg === "string" && msg.trim() !== "");
          this.showToast(firstError || fallbackMsg, "error");
        } else {
          this.showToast(fallbackMsg, "error");
        }
      } else if (data.status === 200) {
        const newLink = data.form_link || null;
        this.setState({ errorMessageSaveResponse: "", apiFieldErrors: null });
        this.showToast(
          "Your response was submitted successfully!",
          "success",
          "Submitted"
        );

        setTimeout(() => {
          this.props.props.history.push("/cp_forms");
        }, 3500);
      } else {
        // Any other backend status (e.g. 405) — surface the error to the user.
        const msg =
          (typeof data.errors === "string" ? data.errors : data.errors?.message) ||
          data.message ||
          "There was an error while submitting the form.";
        this.showToast(msg, "error");
      }
    } catch (err) {
      console.error("❌ saveResponse error:", err);
      this.showToast(
        err?.response?.data?.errors?.message ||
          (typeof err?.response?.data?.errors === "string"
            ? err.response.data.errors
            : null) ||
          err?.response?.data?.message ||
          err?.message ||
          "An unexpected error occurred.",
        "error"
      );
    } finally {
      // ✅ Always stop loader
      this.setState({ isSubmitting: false });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  stopAIAgent = async () => {
    const { stopUrl, agentPid } = this.state;
    this.setState({
      isStoppingAgent: true,
      responseMessage: "", // clear old messages immediately
    });
    window.scrollTo({ top: 0, behavior: "smooth" });

    try {
      const submitFormResponse = await stopAIAgent(
        auth.getAccount(),
        auth.getToken(),
        "drc", // agent_type
        "stop", // action
        agentPid, // pid
        stopUrl // stop_url
      );

      const data = submitFormResponse.data;

      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (data.status === 404) {
        this.setState({
          isStoppingAgent: false,
          responseMessage:
            '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There was an error while stopping the AI Agent.</div>',
        });
        return;
      }

      if (data.status === 200) {
        // ✅ Step 1: Show loader only (no success yet)

        // ✅ Step 2: Wait 3s while loader is visible
        await new Promise((resolve) => setTimeout(resolve, 3000));

        // ✅ Step 3: Now show success message, then redirect
        this.setState({
          showIframeModal: false,
          isStoppingAgent: false,
          responseMessage:
            '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> AI Agent stopped successfully!</div>',
        });

        // Short grace period for user to see success text
        await new Promise((resolve) => setTimeout(resolve, 1500));

        // ✅ Step 4: Redirect cleanly
        window.location.href = "/cp_forms";
        return;
      }

      this.setState({
        isStoppingAgent: false,
        responseMessage:
          '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> Unexpected error while stopping the AI Agent.</div>',
      });
    } catch (error) {
      console.error("❌ Error stopping agent:", error);
      this.setState({
        isStoppingAgent: false,
        responseMessage:
          '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> Network error while stopping the AI Agent.</div>',
      });
    }
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content " id="Support_Block">
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              {/* RIGHTS MODAL START */}

              {/* RIGHTS MODAL End */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <HomeIcon fontSize="inherit" className="" />
                        Home
                      </Link>
                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/cp_forms")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        Forms
                      </Link>

                      <Typography color="textPrimary" className="">
                        Submit Form
                      </Typography>
                    </Breadcrumbs>
                  </div>
                  {/* <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block form_main_container">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        {this.state.isSubmitting && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              zIndex: 10,
                            }}
                          >
                            <div
                              className="spinner-border text-primary mb-2"
                              style={{ width: "2.5rem", height: "2.5rem" }}
                              role="status"
                            />
                            <span
                              style={{
                                color: "#555",
                                fontSize: "15px",
                                fontWeight: 500,
                                marginTop: "4px",
                              }}
                            >
                              Submitting your response...
                            </span>
                          </div>
                        )}

                        <div className="card-inner">
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <>
                              {this.state.link_form === 1 ? (
                                <div className="nk-block mt-4">
                                  <div className="nk-block-content nk-error-ld">
                                    <h3 className="nk-error-title text-center">
                                      Link Only
                                    </h3>
                                    <div className="alert alert-light text-dark">
                                      This form contains an external link.{" "}
                                      <a
                                        href={this.state.external_link}
                                        target="_blank"
                                      >
                                        Click Here
                                      </a>{" "}
                                      to be redirected to the specified
                                      destination.
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {this.state.form_submitted === "No" ? (
                                    <FormRendererAgent
                                      formData={JSON.parse(this.state.formData)}
                                      formTitle={this.state.form_title}
                                      formDescription={this.state.form_desc}
                                      onSubmit={this.handleSubmitForm}
                                      onToast={this.showToast}
                                      apiFieldErrors={this.state.apiFieldErrors}
                                      groups={this.state.groups}
                                      responseMessage={
                                        this.state.responseMessage
                                      }
                                      clientData={this.state.client_details}
                                      chatgpt_intergation={
                                        this.state.chatgpt_intergation
                                      }
                                      chatgpt_api_key={
                                        this.state.chatgpt_api_key
                                      }
                                      allow_submit={this.state.allow_submit}
                                      draftData={this.state.draftData}
                                      saveDraft={this.handleSaveDraft}
                                      progressStep={this.state.progressStep}
                                      viewFrom="agent-logged-in"
                                      allow_agent_name={
                                        this.state.allow_agent_name
                                      }
                                      isSubmitting={this.state.isSubmitting}
                                      captcha_enabled={this.state.captcha_enabled}
                                      link_form={this.state.link_form}
                                      //id={this.state.forms[0].id}
                                      //setShowResponse={(value) => this.setState({ showResponse: value })}
                                    />
                                  ) : this.state.form_submitted === "Yes" ? (
                                    <>
                                      {this.state.allow_multiple === 1 ? (
                                        <FormRendererAgent
                                          formData={JSON.parse(
                                            this.state.formData
                                          )}
                                          formTitle={this.state.form_title}
                                          formDescription={this.state.form_desc}
                                          onSubmit={this.handleSubmitForm}
                                          onToast={this.showToast}
                                          groups={this.state.groups}
                                          responseMessage={
                                            this.state.responseMessage
                                          }
                                          clientData={this.state.client_details}
                                          chatgpt_intergation={
                                            this.state.chatgpt_intergation
                                          }
                                          chatgpt_api_key={
                                            this.state.chatgpt_api_key
                                          }
                                          allow_submit={this.state.allow_submit}
                                          draftData={this.state.draftData}
                                          saveDraft={this.handleSaveDraft}
                                          progressStep={this.state.progressStep}
                                          viewFrom="agent-logged-in"
                                          allow_agent_name={
                                            this.state.allow_agent_name
                                          }
                                          isSubmitting={this.state.isSubmitting}
                                          captcha_enabled={this.state.captcha_enabled}
                                          link_form={this.state.link_form}
                                          //id={this.state.forms[0].id}
                                          //setShowResponse={(value) => this.setState({ showResponse: value })}
                                        />
                                      ) : this.state.allow_multiple === 0 ? (
                                        <div className="nk-block mt-4">
                                          <div className="nk-block-content nk-error-ld">
                                            <h3 className="nk-error-title text-center">
                                              Form Submitted
                                            </h3>
                                            <div className="alert alert-light text-dark">
                                              Thank you for submitting your
                                              form. We have successfully
                                              received your information and are
                                              processing it. Our team will
                                              review the details and get back to
                                              you shortly if further information
                                              is needed. We appreciate your time
                                              and effort in providing us with
                                              the necessary details.
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  ) : this.state.form_submitted === "3" ? (
                                    <div className="nk-block mt-4">
                                      <div className="nk-block-content nk-error-ld  text-center">
                                        <h3 className="nk-error-title">
                                          Form Unavailable
                                        </h3>
                                        <div className="alert alert-light text-dark">
                                          We are very sorry for inconvenience.
                                          It looks like you’re try to access a
                                          form that either has been expired or
                                          already submitted.
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {this.state.showIframeModal && (
                    <div
                      className="modal fade show"
                      style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                      }}
                    >
                      <div
                        className="modal-dialog modal-dialog-centered modal-xl"
                        style={{
                          width: "90%",
                          maxWidth: "1400px",
                          position: "relative",
                        }}
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-monitor"></em> AI Agent
                              Sandbox
                            </h5>

                            <button
                              type="button"
                              className="close"
                              onClick={() => {
                                this.setState({ showIframeModal: false });
                                window.location.href = "/cp_forms";
                              }}
                              disabled={this.state.isStoppingAgent}
                            >
                              <em className="icon ni ni-cross"></em>
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            style={{
                              height: "70vh",
                              padding: 0,
                              position: "relative",
                            }}
                          >
                            <iframe
                              src={this.state.iframeUrl}
                              title="AI Agent Sandbox"
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                                borderRadius: "8px",
                              }}
                              allow="microphone; camera; clipboard-read; clipboard-write"
                            ></iframe>
                            {this.state.isStoppingAgent && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0.85)",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  zIndex: 10000,
                                  transition: "opacity 0.3s ease-in-out",
                                }}
                              >
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                  style={{ width: "3rem", height: "3rem" }}
                                />
                                <p className="mt-3 text-dark font-weight-bold">
                                  Stopping AI Agent… Please wait
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="modal-footer">
                            <button
                              className="btn btn-danger"
                              onClick={this.stopAIAgent}
                              disabled={this.state.isStoppingAgent}
                            >
                              {this.state.isStoppingAgent ? (
                                <>
                                  <em className="icon ni ni-loader mr-1 animate-spin"></em>
                                  Stopping…
                                </>
                              ) : (
                                <>
                                  <em className="icon ni ni-power"></em> Stop
                                  Agent
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormSubmit);
